import { ProviderApi, ProviderDataType } from "@/api/ProviderApi";
import { drain } from "./core/drain";

export type ExistingProviderData = {
    providers: ProviderDataType[];
};

/**
 * Trae todos los proveedores del tenant.
 *
 * La importacion los necesita completos para detectar duplicados (por codigo y por
 * identificacion) y para generar codigos consecutivos sin volver a consultar por fila.
 * `ProviderApi` no sobreescribe `fetchAll` ni fuerza un selectionSet pesado, asi que
 * `drain` sirve tal cual.
 */
export const loadExistingProviderData = async (): Promise<ExistingProviderData> => ({
    providers: await drain(ProviderApi),
});
